import React, { useCallback } from "react";
import styles from "./style.scss";
import { getIconUrl } from "../../../../../services/asset";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../../../routes/Auth/auth.ducks";
import { UserRole } from "../../../../../models";

export interface LogoTileProps {
  title: string;
  logoId: string;
  onClick: () => void;
  isSelected: boolean;
  disabled: boolean;
}

const LogoTile = (props : LogoTileProps) : JSX.Element => {
  const { title, logoId, onClick, isSelected, disabled } = props;
  const userData = useSelector(selectUserInfo);

  const userCanEdit = useCallback(() => {
    return (
      userData.role === UserRole.admin ||
      userData.role === UserRole.superAdmin
    );
  }, [userData]);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.tile} ${isSelected ? styles.selected : ""}`}
      disabled={disabled && !userCanEdit()}
      style={{ cursor: `${disabled && !userCanEdit() ? "not-allowed" : "pointer"}` }}
    >
      
      <img src={getIconUrl("make/" + logoId)} alt={title} />
      <p>{title && title.split("-")[0]}</p>
    </button>
  );
}

export default LogoTile;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiLevelSelectorWithLogo/LogoSelector/LogoTile/index.tsx